<template>
    <div class="node-theme-container">
        <div class="node-theme" v-for="theme in nodesByTheme">
            <span class="theme-name">{{ theme.name }}</span>
            <div class="node-button-container" v-for="constructor in theme.constructors">
                <button class="node-button"  
                    draggable="true"
                    :title="constructor.prototype.description"
                    @click="$emit('create', constructor)" 
                    @dragstart="handleDragStart($event, constructor)"
                    @dragend="handleDragEnd($event, constructor)">
                    <img :src="'/icons/nodes/' + constructor.prototype.name + '.svg'">
                </button>
            </div>
        </div>
        <button class="material-icons" 
            :class="{ 'advanced-button': true, selected: showAdvanced }" 
            @click="showAdvanced = !showAdvanced">calculate</button>
    </div>
</template>

<script>
import * as nodes from "../nodes";

export default {
    name: 'node-editor',
    data() {
        return {
            showAdvanced: false
        };
    },
    computed: {
        nodesByTheme() { return nodes.nodesByTheme.filter(theme => !theme.advanced || this.showAdvanced); }
    },
    methods: {
        handleDragStart(e, constructor) {
            e.dataTransfer.setData("node-constructor", constructor.prototype.name);
        },
        handleDragEnd(e, constructor) {
        }
    }
}
</script>

<style scoped lang="less">
.node-theme-container
{
    position: relative;
    display: flex;
    flex-wrap: wrap;
    padding: 10px;
    padding-top: 0;
}
.node-theme
{
    margin-right: 12px;
}
#node-editor-popup
{
    position: fixed;
    top: 0;
    left: 0;
    width: 40vw;
    background-color: #eee;
    border: 1px solid #ddd;
}
.theme-name
{
    display: block;
    font-size: 70%;
    margin-top: 10px;
    margin-bottom: 0.4em;
    color: #999;
}
.node-button
{
    margin: 2px;
    padding: 10px 10px;
    border-radius: 5px;
    border: 0;
    background-color: white;
}
.node-button:focus
{
    outline: none;
}
.node-button:hover
{
    background-color: #f9f9f9;
}
.node-button-container
{
    display: inline-flex;
    flex-direction: column;
    font-size: 80%;
}
.advanced-button
{
    position: absolute;
    right: 4px;
    top: 4px;
    color: gray;
    border: none;
    margin: 0;
    padding: 0;
}
.advanced-button.selected
{
    color: darken(#66c8ff, 20%);
}
</style>
